import "./../../bindings/bao-searcher";
import "./../../bindings/bao-toolbar2";
import GenericListTab from "./../../factories/generic-list-tab";
import * as ko from "knockout";
import * as $ from "jquery";
import Bao from "./../../services/bao-service";
import BaoDialog from "./../../factories/bao-dialog";
class TagOrgUnitViewModel extends GenericListTab {
    constructor(tabPage, parent) {
        super(tabPage, parent);
        //this.SearchConfig.CustomFilter = { SessionTabId: this.SessionTabId, DistinctSessionObjects: true };
    }
    CustomFilter(): Models.HashObject[] {
        return null;
    }
    SearchType(): string {
        return "OrgUnit";
    }
    ControllerUrl = "TagOrgUnit";
    ItemCompleteCheck(item: any): JQueryPromise<boolean> {
        return $.Deferred<boolean>().resolve(true).promise();
    }
}
export default TagOrgUnitViewModel;